import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Row, Form, Button } from "@themesberg/react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import JoditEditor from "jodit-react";
import { BaseUrl } from "../Routes/BaseUrl";
import slugify from "slugify";

const types = ["legal", "investor panel", "avijobs", "avijo main"];

export const BlogComponent = () => {
  const navigate = useNavigate();
  const editor = useRef(null);
  const [categories, setCategories] = useState([]);
  const [addCat, setAddCat] = useState(false);
  const {
    control,
    handleSubmit,
    setValue,
    register,
    getValues,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      title: "",
      category: "",
      subCategory: "",
      content: "",
      type: "",
      blogImage: null,
      status: true // Set default status to publish (true)
    },
  });

const fetchCategory = async () => {
  const token = localStorage.getItem("token");
  const unwantedCategories = ["Provider","General","Healthtech","67fcb2df4fcf2ee548a85df9", "67fcb1864fcf2ee548a85df5", "680cd86c7e06860cde174e1b"]; 

  try {
    const response = await fetch(`${BaseUrl.trim()}/admin/blog/all-category`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const json = await response.json();
    const filtered = json?.data?.filter(cat => !unwantedCategories.includes(cat.category));
    setCategories(filtered); // Only allowed categories now
    console.log("Filtered categories:", filtered);
  } catch (e) {
    console.error("Error fetching categories:", e);
  }
};

  useEffect(() => {
    fetchCategory();
  }, []);

  const onSubmit = async (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === "blogImage" && data[key]) {
        formData.append("imageUrl", data[key]);
      } else {
        formData.append(key, data[key]);
      }
    });
    formData.append("slug", slugify(data.title, { lower: true, strict: true, remove: /[^a-zA-Z0-9\s]/g }));

    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const toastId = toast.loading("Creating blog...");
    try {

      const response = await axios.post(`${BaseUrl.trim()}/admin/blog/create`, formData, config);
      console.log("This is the response = ", response);
      if (response.status === 201) {
        toast.success("Blog created successfully");
      }
    } catch (error) {
      console.log("Detailed error:", error.response?.data || error.message);
      toast.error(`Failed to create blog: ${error.response?.data?.message || error.message}, error: ${error}`);
    } finally {
      toast.dismiss(toastId);
    }
  };

  const categoryChangeHandler = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "addNew") {
      setValue("category", "");
      setAddCat(true);
    } else {
      setValue("category", selectedValue);
      setAddCat(false);
    }
  }

  return (
    <>
      <h5 className="mb-4">Create Blog</h5>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Posted by </Form.Label>
              <Form.Control {...register("postedBy", { required: "Name is required who posting the blog" })} placeholder="Enter the name" />
              {errors.postedBy && <p className="text-danger">{errors.postedBy.message}</p>}
            </Form.Group>
          </Col>

        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Title</Form.Label>
              <Form.Control {...register("title", { required: "Title is required" })} placeholder="Enter blog title" />
              {errors.title && <p className="text-danger">{errors.title.message}</p>}
            </Form.Group>
          </Col>

          <Col md={6}>
            {!addCat ? (
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select {...register("category", { required: "Category is required" })} onChange={categoryChangeHandler}>
                  <option value="">Select category</option>
                  {categories.map((cat) => (<option key={cat._id} value={cat.category}>{cat.category}</option>))}
                  <option value="addNew">Add Category</option>
                </Form.Select>
                {errors.category && <p className="text-danger">{errors.category.message}</p>}
              </Form.Group>
            ) : (
              <Form.Group>
                <Form.Label>New Category</Form.Label>
                <Form.Control {...register("category", { required: "New category is required" })} placeholder="Enter new category" />
                <Button variant="link" onClick={() => setAddCat(false)}>Cancel</Button>
              </Form.Group>
            )}
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label>SubCategory</Form.Label>
              <Form.Control {...register("subCategory")} placeholder="Enter subcategory (Optional)" />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Blog Image</Form.Label>
              <Form.Control type="file" onChange={(e) => setValue("blogImage", e.target.files[0])} />
              {watch("blogImage") && <p>Uploaded File: {watch("blogImage").name}</p>}
            </Form.Group>
          </Col>
        </Row>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Upload On</Form.Label>
            <Form.Select {...register("type", { required: "Type is required" })}>
              <option value="">Select option</option>
              {types.map((type) => (<option key={type} value={type}>{type}</option>))}
            </Form.Select>
            {errors.type && <p className="text-danger">{errors.type.message}</p>}
          </Form.Group>
        </Col>

        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label>Content</Form.Label>
              <Controller name="content" control={control} rules={{ required: "Content is required" }} render={({ field }) => (
                <JoditEditor ref={editor} onChange={(newContent) => field.onChange(newContent)} />
              )} />
              {errors.content && <p className="text-danger">{errors.content.message}</p>}
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Publication Status</Form.Label>
          <div className="d-flex gap-4">
            <Form.Check
              type="radio"
              id="status-publish"
              label="Publish"
              value={true}
              {...register("status")}
              defaultChecked={watch("status") === true}
            />
            <Form.Check
              type="radio"
              id="status-draft"
              label="Draft"
              value={false}
              {...register("status")}
              defaultChecked={watch("status") === false}
            />
          </div>
        </Form.Group>

        <div className="mt-3">
          <Button variant="primary" type="submit">Submit</Button>
        </div>
      </Form>
    </>
  );
};